import React, { useEffect } from 'react';
import Preloader from '../../components/Preloader';
import Banner from '../../components/Banner';
import Listing from './Listing';

/** Body class names specific to this page */
const BODY_CLASSES = ['inner-page', 'blog'];

/**
 * Blog Page Component
 *
 * Adds and removes specific body classes for layout styling.
 *
 * @component
 */
const BlogPage = () => {
    useEffect(() => {
        BODY_CLASSES.forEach(cls => document.body.classList.add(cls));
        return () => {
            BODY_CLASSES.forEach(cls => document.body.classList.remove(cls));
        };
    }, []); // No warning now, BODY_CLASSES is stable

    return (
        <>
            <Preloader />
            <Banner page={{ title: 'Blog' }} />
            <Listing type="blog" />
        </>
    );
};

export default BlogPage;
